import { createContext, } from 'react';

const AccountsPageContext = createContext({});

export default AccountsPageContext;